module.exports = "/static/assets/5615aa7220494ca18b0b3371956d153a.png";